import { useMemo } from 'react';
import { rage, useObservable } from '~/rage';

export const useContactName = (
	phoneNumber: string | null | undefined,
): string => {
	const contacts = useObservable(rage.contacts.getContacts()) ?? [];

	return useMemo(() => {
		if (phoneNumber === null || phoneNumber === undefined) {
			return '';
		}
		const contact = contacts.find((c) => c.phoneNumber === phoneNumber);
		return contact?.name ?? '';
	}, [contacts, phoneNumber]);
};
